import { CREATE_BRAND_PROJECT_ROUTE_ID, LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { GET_STARTED_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { colorsNew } from 'root/src/client/web/commonStyles'
import {
	levelKey,
	platformKey,
} from 'root/src/shared/constants/keys'
import {
	dropDareDifficultyLevelEnum,
	dropDareDifficultyEstimatedTime,
	readableDropDareDifficultyLevels,
} from 'root/src/shared/constants/dropEvent'
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn'
import { faBadgeCheck } from '@fortawesome/pro-light-svg-icons/faBadgeCheck'
import { faGamepadAlt } from '@fortawesome/pro-light-svg-icons/faGamepadAlt'
import ANCHORS from 'root/src/shared/constants/anchors'
import { darePlatformFilters } from 'root/src/client/v2/drop/constants'

export default {
	howToSection: {
		title: 'New Here?',
		subtitle: 'You’ll catch on quick. Here’s how to get started on Dare Drop:',
		steps: [
			{
				icon: { icon: faSignIn, color: colorsNew.primary },
				cta: 'Sign Up',
				content: 'First, create an account. It’s totally free, no cost to you.',
			},
			{
				icon: { icon: faBadgeCheck, color: colorsNew.pink },
				cta: 'Accept Dares',
				content: 'Accept any (or all!) of the dares you want to try on this page.',
			},
			{
				icon: { icon: faGamepadAlt, color: colorsNew.teal },
				cta: 'Play Games',
				content: 'We’ll email you a game key. Play the game and win rewards for your fans! ',
			},
		],
		buttons: [{
			label: 'Sign Up',
			moduleId: GET_STARTED_MODULE_ID,
			type: 'primary',
		},
		{
			anchorId: ANCHORS.DROP_FAQ_SECTION,
			label: 'Read some FAQs',
			type: 'secondary',
		}],
	},
	daresSection: {
		primaryHeading: 'The Drop—',
		secondaryHeading: gameName => `All Dares for ${gameName}`,
		linkRouteId: LOGIN_ROUTE_ID,
		redirectRouteId: CREATE_BRAND_PROJECT_ROUTE_ID,
		filters: {
			[platformKey]: darePlatformFilters
				.map(({ icon, color, value: platform }) => ({
					id: platform,
					label: ({ id, active, onChange }) => (
						<button
							type="button"
							style={{
								overflow: 'hidden',
								marginInline: 5,
								border: '3px solid transparent',
								borderColor: active ? colorsNew.primary : 'transparent',
								background: color,
								width: 36,
								height: 36,
								borderRadius: '100%',
								cursor: 'pointer',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							onClick={() => onChange(id)}
						>
							<img
								style={{
									width: '100%',
									height: '100%',
									marginTop: id === 'youtube' ? '2px' : 0,
								}}
								src={icon.src}
								alt={platform}
							/>
						</button>
					),
					active: true,
				})),
			[levelKey]: Object.values(dropDareDifficultyLevelEnum)
				.map(level => ({
					id: level,
					label: readableDropDareDifficultyLevels[level],
					tooltip: dropDareDifficultyEstimatedTime[level],
					active: true,
				})),
		},
		loggedInText: 'Click on one to get started.',
		notLoggedInText: 'Sign in to start accepting dares.',
	},
}
